export class Filtro {
  exibicao: string; //texto que vai aparecer
  chave: string; //tipo, identificador único
  id: string; //chave de busca
  hint: string; //apenas para exibir um hint
}

/*

operadora-nome ->
operadora-id ->
serie-id ->
serie-nome ->

*/
